import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { OauthTokenDataObject } from 'models/service';

type TokenLoginRequest = {
  /* eslint-disable @typescript-eslint/naming-convention -- Start: Keys are defined by Backend API endpoint */
  grant_type: 'password';
  login_token: string;
  login_token_type?: 'magic_token';
  /* eslint-enable @typescript-eslint/naming-convention -- End: Keys are defined by Backend API endpoint */
};

export const loginWithToken = async (data: TokenLoginRequest) =>
  apiClient.post<OauthTokenDataObject, ApiClientResponse<OauthTokenDataObject>>(routes.oauth.token, data, {
    skipAuth: true,
  });
